
const initialState = {
  createAction: '',
  redirectCurie: 'unknown reference',
  redirectToBiblio: false,
  searchPmidLoading: false,
  createPmidLoading: false,
  createAllianceLoading: false,
  createModalText: '',
//   biblioUpdating: 0,
//   referenceCurie: '',
//   referenceJsonLive: {},
//   referenceJsonDb: {},
//   referenceJsonHasChange: {},
//   loadingQuery: true,
//   queryFailure: false,
//   getReferenceCurieFlag: true,
//   meshExpand: 'short',
//   authorExpand: 'first',
//   hasPmid: false,
  modIdent: '',
  modPrefix: '',
  allianceOnly: false,
  pmid: '',
  doi: '',
  pmidTitle: 'Enter a PMID',
  pmidQuerySuccess: false,
  pmidXml: '',
  resourceCuriePrefix: 'NLM',
  resourceCurieValue: '',
  resourceTitle: 'Pick a curie prefix and enter rest of curie',
  resourceQuerySuccess: false,
  resourceExistsCuries: null,
  resourceLoading: '',
  resourceCreatedMessage: '',
  resourceError: '',
  updateAlert: 0,
  updateFailure: 0,
  updateMessages: []
};

// to ignore a warning about Unexpected default export of anonymous function
// eslint-disable-next-line
export default function(state = initialState, action) {
  // action will have a type.  common to evaluate with a switch
  switch (action.type) {
    case 'CHANGE_CREATE_ACTION_TOGGLER':
      // console.log(action.payload);
      return {
        ...state,
        createAction: action.payload
      }
    case 'CREATE_CHANGE_FIELD':
      // console.log(action.payload);
      return {
        ...state,
        [action.payload.field]: action.payload.value
      }
    case 'CREATE_CHANGE_PMID_FIELD':
      // console.log(action.payload);
      return {
        ...state,
        pmid: action.payload.value,
        pmidQuerySuccess: false
      }
    case 'CREATE_SET_PMID_SEARCH_LOADING':
      // console.log(action.payload);
      return {
        ...state,
        searchPmidLoading: true
      }
    case 'SET_CREATE_MODAL_TEXT':
      // console.log('SET_CREATE_MODAL_TEXT reducer ' + action.payload);
      return {
        ...state,
        createModalText: action.payload
      }
    case 'SET_CREATE_ACTION':
      console.log("reducer set create action");
      return {
        ...state,
        createAction: action.payload
      }
    // Clearing at create-start (below) only covers a second create made without leaving the
    // page. This covers arriving at Create with an alert still in the store from last time.
    // updateAlert is reset alongside them: nothing reads it today, but it is the counter a
    // dismissible alert here would key off, and leaving it monotonic would be a trap.
    case 'RESET_CREATE_ALERT':
      return {
        ...state,
        updateAlert: 0,
        updateFailure: 0,
        updateMessages: []
      }
    case 'RESET_CREATE_REDIRECT':
      console.log("reset create redirect");
      return {
        ...state,
        redirectCurie: 'unknown reference',
        redirectToBiblio: false
      }
    case 'CREATE_QUERY_PMID_PUBMED':
      console.log("reducer create query pmid pubmed");
      return {
        ...state,
        searchPmidLoading: false,
        pmidTitle: action.payload || 'no reference found for PMID:' + state.pmid.replace(/[^\d.]/g, ''),
        pmidQuerySuccess: !!action.payload
      }
    case 'CREATE_QUERY_PMID_XREF':
      console.log("reducer create query pmid xref");
      return {
        ...state,
        searchPmidLoading: false,
        redirectCurie: action.payload,
        redirectToBiblio: true
      }
    // Both create-loading actions are dispatched the moment a create starts, which is the
    // right point to drop the previous attempt's alert. Without this, a message survives the
    // create that produced it -- the curator comes back to Create later and reads a red error
    // about a reference that was made minutes ago and is perfectly fine.
    case 'CREATE_SET_PMID_CREATE_LOADING':
      // console.log(action.payload);
      return {
        ...state,
        updateFailure: 0,
        updateMessages: [],
        createPmidLoading: true
      }
    case 'CREATE_SET_ALLIANCE_CREATE_LOADING':
      // console.log(action.payload);
      return {
        ...state,
        updateFailure: 0,
        updateMessages: [],
        createAllianceLoading: true
      }
    case 'UPDATE_BUTTON_CREATE_ALREADY_EXISTS':
      let createAlreadyPmidLoading = state.createPmidLoading;
      let createAlreadyAllianceLoading = state.createAllianceLoading;
      if (action.payload.pmidOrAlliance === "pmid") {
          createAlreadyPmidLoading = false; }
        else if (action.payload.pmidOrAlliance === "alliance") {
          createAlreadyAllianceLoading = false; }
      return {
        ...state,
        createPmidLoading: createAlreadyPmidLoading,
        createAllianceLoading: createAlreadyAllianceLoading,
        createModalText: action.payload.responseMessage
      }
    case 'UPDATE_BUTTON_CREATE':
      console.log('reducer UPDATE_BUTTON_CREATE ' + action.payload.responseMessage);
      console.log('reducer value ' + action.payload.value);
      let newUpdateFailure = 0;
      // copy, never alias: the pushes below would otherwise mutate the store in place, and
      // for an untouched store that array is the module-level initialState singleton
      let newArrayUpdateMessages = [...state.updateMessages];
      let redirectCurie = state.redirectCurie;
      let redirectToBiblio = false;
      let createPmidLoading = state.createPmidLoading;
      let createAllianceLoading = state.createAllianceLoading;
      if (action.payload.pmidOrAlliance === "pmid") {
          createPmidLoading = false; }
        else if (action.payload.pmidOrAlliance === "alliance") {
          createAllianceLoading = false; }
       
//       let getReferenceCurieFlagUpdateButton = false;
//       let hasChangeUpdateButton = state.referenceJsonHasChange;
      if (action.payload.responseMessage === "update success") {
        console.log('reducer UPDATE_BUTTON_CREATE ' + action.payload.responseMessage);
        if (action.payload.value === null || action.payload.value === undefined) {
          // The reference was created, but nothing usable came back to redirect to.
          // Redirecting anyway is the silent failure this guard exists to stop: the curator
          // lands on ?referenceCurie=null looking at an empty editor, with no error anywhere
          // and no hint that the reference does exist. Report it instead, so a renamed field,
          // a reverted response_model, or a new call site that forgets to name its id field
          // announces itself the day it lands rather than months later.
          const named = action.payload.subField ? ` ("${action.payload.subField}")` : '';
          newArrayUpdateMessages.push(
            `The reference was created, but the API response carried no identifier${named} to `
            + `open it with, so it could not be displayed. Find it via search.`);
          newUpdateFailure = 1;
          console.log('Update success with no id to redirect to');
        } else {
          newArrayUpdateMessages = [];
          redirectToBiblio = true;
          redirectCurie = action.payload.value;
        }
//         getReferenceCurieFlagUpdateButton = true;
//         hasChangeUpdateButton = {};
      } else {
        newArrayUpdateMessages.push(action.payload.responseMessage);
        newUpdateFailure = 1;
        console.log('Update failure ' + action.payload.responseMessage);
      }
//       let referenceJsonLive = state.referenceJsonLive;
//       if ((action.payload.field !== null) && 		// POST to a field, assign its db id to redux store
//           (action.payload.subField !== null)) {		// but only for related tables that create a dbid, not for cross_references
//         referenceJsonLive[action.payload.field][action.payload.index][action.payload.subField] = action.payload.value; }
      return {
        ...state,
        createPmidLoading: createPmidLoading,
        createAllianceLoading: createAllianceLoading,
        modIdent: '',
//         referenceJsonLive: referenceJsonLive,
        redirectCurie: redirectCurie,
        redirectToBiblio: redirectToBiblio,
        updateAlert: state.updateAlert + 1,
        updateFailure: state.updateFailure + newUpdateFailure,
        updateMessages: newArrayUpdateMessages
//         getReferenceCurieFlag: getReferenceCurieFlagUpdateButton,
//         referenceJsonHasChange: hasChangeUpdateButton,
//         biblioUpdating: state.biblioUpdating - 1
      }
    case 'CREATE_CHANGE_RESOURCE_CURIE_VALUE':
      return {
        ...state,
        resourceCurieValue: action.payload.value,
        resourceQuerySuccess: false,
        resourceExistsCuries: null,
        resourceCreatedMessage: '',
        resourceError: ''
      }
    case 'CREATE_SET_RESOURCE_LOADING':
      return {
        ...state,
        resourceLoading: action.payload
      }
    case 'CREATE_QUERY_RESOURCE_RESULT':
      const { exists_in_db, resource_curies, external_curie_found, title, curie } = action.payload;
      if (exists_in_db) {
        return { ...state, resourceLoading: '', resourceExistsCuries: resource_curies,
                 resourceQuerySuccess: false, resourceTitle: 'Already exists in database' };
      } else if (external_curie_found) {
        return { ...state, resourceLoading: '', resourceTitle: title,
                 resourceQuerySuccess: true, resourceExistsCuries: null };
      } else {
        return { ...state, resourceLoading: '',
                 resourceTitle: curie + ' not found in database or external APIs',
                 resourceQuerySuccess: false, resourceExistsCuries: null };
      }
    case 'CREATE_RESOURCE_CREATED':
      return {
        ...state,
        resourceLoading: '',
        resourceQuerySuccess: false,
        resourceCreatedMessage: action.payload,
        resourceError: ''
      }
    case 'CREATE_RESOURCE_CREATE_ERROR':
      return {
        ...state,
        resourceLoading: '',
        resourceCreatedMessage: '',
        resourceError: action.payload
      }
    default:
      return state;
  }
}
